/**
 * 组件使用场景：添加买家
 * */
import React, { Component } from 'react';
import { Modal, Form, Button, Input } from 'antd';
import { connect } from '@souche-f2e/muji';
import { dispatch } from '@@/store';
import { CHECK_name, CHECK_buyerCode } from '@/shared/reqexp';
import { CarPosition } from '@/components';
import styled from 'styled-components';
import { fontEndConfig } from '@/shared/utils';
const BtnDiv = styled.div `
  display: flex;
  justify-content: center;
  .btn{
    width:76px;
    height:36px;
    margin: 0 10px;
  }
`;
const mapStateToProps = (rootState) => ({
    buyer: rootState.buyer,
});
class EditMsg extends Component {
    constructor(props) {
        super(props);
        this.checkedPosition = [];
        this.cancel = this.cancel.bind(this);
        this.afterClose = this.afterClose.bind(this);
        this.save = this.save.bind(this);
    }
    // desc 关闭回调
    cancel() {
        dispatch.buyer.HIDE_EDIT();
    }
    // desc 关闭后重置数据
    afterClose() {
        this.props.form.resetFields();
        this.checkedPosition = [];
    }
    // 保存
    save() {
        const { editMsgData = {} } = this.props.buyer;
        this.props.form.validateFields()
            .then((data) => {
            if (data.numberPlate) {
                data.numberPlate = data.numberPlate.padStart(3, '0');
            }
            if (data.position && data.position.length > 0) {
                delete data.position;
                const [provinceData = {}, cityData = {}] = this.checkedPosition;
                data.provinceCode = provinceData.value || editMsgData.provinceCode;
                data.provinceName = provinceData.label || editMsgData.provinceName;
                data.cityCode = cityData.value || editMsgData.cityCode;
                data.cityName = cityData.label || editMsgData.cityName;
            }
            dispatch.buyer.editMsg(data);
        });
    }
    render() {
        const { editVisible, editMsgData = {} } = this.props.buyer;
        const { getFieldDecorator } = this.props.form;
        return (<Modal title={'编辑买家详情'} centered footer={null} visible={editVisible} width={600} onCancel={this.cancel} afterClose={this.afterClose}>
        <Form labelCol={{
            span: 5,
            offset: 2,
        }} wrapperCol={{ span: 14 }}>
          <Form.Item label={<>号码牌<span style={{ color: '#999999' }}>(选填)</span></>}>
            {getFieldDecorator('numberPlate', {
            initialValue: editMsgData.numberPlate === fontEndConfig.noValueReplace ? undefined : editMsgData.numberPlate,
            rules: [
                {
                    pattern: CHECK_buyerCode,
                    message: '请输入3位数字号牌(000-999)',
                },
            ],
        })(<Input placeholder="请输入号码牌"/>)}
          </Form.Item>
          <Form.Item label={<>维护人<span style={{ color: '#999999' }}>(选填)</span></>}>
            {getFieldDecorator('maintainer', {
            initialValue: editMsgData.maintainer === fontEndConfig.noValueReplace ? undefined : editMsgData.maintainer,
            rules: [
                {
                    validator: CHECK_name(20),
                },
            ],
        })(<Input placeholder="请输入姓名"/>)}
          </Form.Item>
          <Form.Item label={<>所在地<span style={{ color: '#999999' }}>(选填)</span></>}>
            {getFieldDecorator('position', {
            initialValue: (editMsgData.provinceCode && editMsgData.cityCode) ? [editMsgData.provinceCode, editMsgData.cityCode] : [],
        })(<CarPosition CascaderProps={{
            placeholder: '请选择',
        }} onChange={(val, options) => {
            this.checkedPosition = options;
        }} precision={'city'}/>)}
          </Form.Item>
        </Form>
        <BtnDiv>
          <Button className={'btn'} onClick={this.cancel}>
            取消
          </Button>
          <Button className={'btn'} type={'primary'} onClick={this.save}>
            保存
          </Button>
        </BtnDiv>
      </Modal>);
    }
}
export default connect(mapStateToProps)(Form.create()(EditMsg));
